export const keyToFreq = {
  // Upper row starting from Q = C3
  'Q': 130.81, // C3
  'W': 138.59, // C#3
  'E': 146.83, // D3
  'R': 155.56, // D#3
  'T': 164.81, // E3
  'Y': 174.61, // F3
  'U': 185.00, // F#3
  'I': 196.00, // G3
  'O': 207.65, // G#3
  'P': 220.00, // A3
  '[': 233.08, // A#3
  ']': 246.94, // B3

  // Middle row starting from A = C4
  'A': 261.63, // C4
  'S': 277.18, // C#4
  'D': 293.66, // D4
  'F': 311.13, // D#4
  'G': 329.63, // E4
  'H': 349.23, // F4
  'J': 369.99, // F#4
  'K': 392.00, // G4
  'L': 415.30, // G#4
  ';': 440.00, // A4
  '\'': 466.16, // A#4
  '\\': 493.88, // B4

  // Lower row starting from Z = C5
  'Z': 523.25, // C5
  'X': 554.37, // C#5
  'C': 587.33, // D5
  'V': 622.25, // D#5
  'B': 659.25, // E5
  'N': 698.46, // F5
  'M': 739.99, // F#5
  ',': 783.99, // G5
  '.': 830.61, // G#5
  '/': 880.00, // A5
  // ...add more mappings as needed
};